application.register("lib-recaptcha", class extends Stimulus.Controller {
    connect() {
        setTimeout(() => this.captcha(this), 2500);

        this.interval = setInterval(() => this.captcha(this), 150000);
    }

    captcha(self) {
        const apiKey = self.element.getAttribute("data-lib-recaptcha");

        importScript(cdnjs.recaptcha.replace("{apikey}", apiKey), function () {
            window.grecaptcha.enterprise.ready(function () {
                window.grecaptcha.enterprise.execute(apiKey, {action: 'form'}).then(function (token) {
                    self.element.querySelector(`[name="gtoken"]`).value = token;
                });
            });
        })
    }

    disconnect() {
        clearInterval(this.interval);
    }
});